// extracted by mini-css-extract-plugin
export default {"scrollShadow":"scrollShadow__hAK00","scrollShadow--atBottom":"scrollShadow--atBottom__9GaFK","scrollShadow--atTop":"scrollShadow--atTop__y7jXV"};